<template>
  <transition name="el-fade-in-linear">
    <div v-show="show" class="middle middleTel">
      <el-container>
          <el-image
            :src="require('@/assets/swhz_2x.png')"
            fit="fill">
          </el-image>
      </el-container>
      <el-container class="partner_info">
        <div class="home_bus">
          <el-image
            src="http://lan-zheng.oss-cn-shanghai.aliyuncs.com/img/icon_phone.png"
            fit="contain">
          </el-image>
          <p class="content">{{$t('el.d.partner_tel')}}</p><br>
        </div>
        <div class="home_bus">
          <el-image
            src="http://lan-zheng.oss-cn-shanghai.aliyuncs.com/img/icon_address.png"
            fit="fill">
          </el-image>
          <br>
          <p class="content">{{$t('el.d.partner_address')}}</p>
        </div>
        <div class="home_bus">
          <el-image
            src="http://lan-zheng.oss-cn-shanghai.aliyuncs.com/img/icon_email.png"
            fit="fill">
          </el-image>
          <br>
          <p class="content">{{$t('el.d.partner_email')}}</p>
        </div>
      </el-container>
      <el-container>
        <a target="_blank" href="https://map.baidu.com/mobile/webapp/search/search/qt=s&da_src=shareurl&wd=%E5%88%9B%E5%B1%95%E5%A4%A7%E5%8E%A6&c=289&src=0&wd2=%E4%B8%8A%E6%B5%B7%E5%B8%82%E9%9D%99%E5%AE%89%E5%8C%BA&pn=0&sug=1&l=13&b=%2813492181%2C3629711%3B13553621%2C3660975%29&from=webmap&biz_forward=%7B%22scaler%22%3A1%2C%22styles%22%3A%22pl%22%7D&sug_forward=979091c2d679b3d44151c0b8&device_ratio=1&&vt=map">
          <el-image
            :src="require('@/assets/location_map.png')"
            fit="fill">
          </el-image>
        </a>
<!--        <div id="dituContent" class="baiduMap">-->
<!--        </div>-->
      </el-container>
      <el-container>
        <Footer id="footer"/>
      </el-container>
    </div>
  </transition>
</template>

<script>
import Footer from '../components/Footer'

export default {
  name: 'partner',
  components: {Footer},
  data () {
    return {
      show: false
    }
  },
  mounted () {
    this.show = true
    // var map = new BMap.Map('dituContent')
    // var poi = new BMap.Point(121.4497985600, 31.2457118100)
    // map.centerAndZoom(poi, 18)
    // map.enableScrollWheelZoom()
    // map.clearOverlays()
    // //var new_point = new BMap.Point(document.getElementById("longitude").value,document.getElementById("latitude").value);
    // var marker = new BMap.Marker(poi) // 创建标注
    // map.addOverlay(marker)              // 将标注添加到地图中
    // map.panTo(poi)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/Partner.vue